import React from "react";
import { Container, Row, Col } from "reactstrap";
import DateTime from "./DateTime";
import Temperature from "./Temperature";
import Attendance from "./Attendance";
import History_illness from "./History_illness";
import Growth from "./Growth";
import CardStatusDashboard from '../../components/CardStatusDashboard';
import { youth , patient , thermometer } from '../../assets/images'

export default function Dashboard() {
  return (
    <Container fluid>
      <Row>
        <Col xs={0} sm={0} md={6} lg={6} xl={6}>
          <p className="txt-header-Dashboard">Welcome to school management</p>
        </Col>

        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
          <DateTime />
        </Col>
      </Row>

      <Row>
      <Col xs={12} sm={12} md={12} lg={12} xl={4}>
          <div>
            <p className="txt-top-title-school-by-nile">
              Triam Udom Suksa School
            </p>
            <p className="txt-under-title">โรงเรียนเตรียมอุดมศึกษา</p>
          </div>
        </Col>

        <Col xs={12} sm={12} md={12} lg={12} xl={8}>
          <Row>
          <Col xs={12} sm={12} md={4} lg={4} xl={4}>
          <CardStatusDashboard
            imageCard={youth}
            HeaderValue="Count"
            FooterValue="350K"
          />
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
          <CardStatusDashboard
            imageCard={patient}
            HeaderValue="High count"
            FooterValue="190"
          />
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
          <CardStatusDashboard
            imageCard={thermometer}
            HeaderValue="Temp"
            FooterValue="38.4°C"
          />
            </Col>
            
          </Row>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
          <div style={{ margin: "20px" }}>
            <Temperature />
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
          <div style={{ margin: "20px" }}>
            <Attendance />
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
        <div style={{ margin: "20px" }}>
     <History_illness />
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
        <div style={{ margin: "20px" }}>
     <Growth />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
